import { action, ActionType } from "typesafe-actions";
import { IError } from "../../../../../../../redux/actions/errorHandlingAction";
import { FlyerDetailCreatePageResponse } from "../types/flyer-detail-create-page-response.interface";
import { FlyerTemplateSummary } from "../../../../../features/flyer-template/types/flyer-template-summary.interface";

export enum FlyerDetailAddPageActions {
  FetchTemplates = "FlyerDetailAddPage/FetchTemplates",
  FetchTemplatesSuccess = "FlyerDetailAddPage/FetchTemplatesSuccess",
  FetchTemplatesFailure = "FlyerDetailAddPage/FetchTemplatesFailure",

  CreatePage = "FlyerDetailAddPage/Create",
  CreatePageSuccess = "FlyerDetailAddPage/CreatePageSuccess",
  CreatePageFailure = "FlyerDetailAddPage/CreatePageFailure",

  GoToFlyer = "FlyerDetailAddPage/GoToFlyer",
}

export const fetchTemplates = () => action(FlyerDetailAddPageActions.FetchTemplates);
export const fetchTemplatesSuccess = (templates: FlyerTemplateSummary[]) =>
  action(FlyerDetailAddPageActions.FetchTemplatesSuccess, templates);
export const fetchTemplatesFailure = (error: IError) =>
  action(FlyerDetailAddPageActions.FetchTemplatesFailure, error);

export const createPage = (flyerId: number, templateId: number) =>
  action(FlyerDetailAddPageActions.CreatePage, { flyerId, templateId });
export const createPageSuccess = (page: FlyerDetailCreatePageResponse) =>
  action(FlyerDetailAddPageActions.CreatePageSuccess, page);
export const createPageFailure = (error: IError) =>
  action(FlyerDetailAddPageActions.CreatePageFailure, error);

export const goToFlyer = (flyerId: number) => action(FlyerDetailAddPageActions.GoToFlyer, flyerId);

const actionCreators = {
  fetchTemplates,
  fetchTemplatesSuccess,
  fetchTemplatesFailure,
  createPage,
  createPageSuccess,
  createPageFailure,
};

export type FlyerDetailAddPageActionType = ActionType<typeof actionCreators>;
